// shared
import runScripts from 'views/assets/scripts/runScripts'

// page specific
import { initMediaGalleries } from 'views/assets/scripts/MediaGallery'
import zoomableImages from 'views/assets/scripts/zoomableImages'
import slider from 'views/assets/scripts/slider'
import registerSliderStretcher from 'views/assets/scripts/registerSliderStretcher'
import videoBox from 'views/assets/scripts/videoBox'
import nowModal from 'views/assets/scripts/nowModal'
import notepad from 'views/assets/scripts/notepad'
import emailNotification from 'views/assets/scripts/emailNotification'
import toggleClass from 'views/assets/scripts/toggleClass'
import productConsultation from 'views/assets/scripts/productConsultation'
import scrollableTables from 'views/assets/scripts/scrollableTables'
import chargeUrlSearchParams from 'views/assets/scripts/chargeUrlSearchParams'
import mountLastActivityContainer from 'views/containers/browser/LastActivityContainer/mountLastActivityContainer'
import mountProductRatingsContainer from 'views/containers/browser/ProductRatingsContainer/mountProductRatingsContainer'
import mountProductVariantsContainer from 'views/containers/browser/ProductVariantsContainer/mountProductVariantsContainer'
import mountSubscriptionClientContainer from 'views/containers/browser/SubscriptionClientContainer/mountSubscriptionClientContainer'
import prescriptionType from 'views/assets/scripts/prescriptionType'
import loginModal from 'views/assets/scripts/loginModal'
import nowCountDown from 'views/assets/scripts/nowCountdown'
import buyBoxSticky from 'views/assets/scripts/buyBoxSticky'
import dismiss from 'views/assets/scripts/dismiss'
import setQueryIDForVariants from 'views/assets/scripts/algoliaTracking'
import handleRatingsAndQnaTabsClicks from 'views/assets/scripts/handleRatingsAndQnaTabsClicks'
import lazyYoutube from 'views/components/organisms/LazyYoutube/lazyYoutube'
import pdpXsellSliderNewAlgoEventsTracking from 'shared/experiments/browser/xsellTopSlider/eventsTracking'
import higherXsellPdpEventsTracking from 'shared/experiments/browser/higherXsellPdp/eventsTracking'
import loadingScript from 'views/assets/scripts/isFormSubmitting'

const animateCartButton = loadingScript({
  formSelector: '[name^=buy-]',
  buttonId: 'AddToCartButton',
  transitionDurationInSec: 1,
  preserveWidth: true
})

runScripts(
  initMediaGalleries,
  zoomableImages,
  chargeUrlSearchParams,
  slider,
  videoBox,
  registerSliderStretcher,
  nowModal,
  emailNotification,
  toggleClass,
  productConsultation,
  scrollableTables,
  mountLastActivityContainer,
  mountProductRatingsContainer,
  mountProductVariantsContainer,
  mountSubscriptionClientContainer,
  prescriptionType,
  loginModal,
  buyBoxSticky,
  dismiss,
  nowCountDown,
  setQueryIDForVariants,
  handleRatingsAndQnaTabsClicks,
  notepad,
  lazyYoutube,
  pdpXsellSliderNewAlgoEventsTracking,
  higherXsellPdpEventsTracking,
  animateCartButton
)
